import * as $ from "jquery";
import portalCodeName from './portal-code-name';

export default (
    function()
    {
        $('input#course_name').on('input', function() {
           var $this = $(this),
               val = $this.val();

           if (val.length > 3)
           {
                $('#course_code').val( portalCodeName(val) );
           }
        });
    }($, portalCodeName)
);